import React from 'react';
import { MapPin } from 'lucide-react';
import { process as steps, areas } from '../data/content';

export function Process() {
  return (
    <section id="prozess" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#B8892A]">Unser Prozess</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0B1E44] leading-tight">
            So einfach läuft Ihre Anfrage ab.
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Transparent von der ersten Nachricht bis zur gepflegten Übergabe – Sie wissen immer, was als Nächstes passiert.
          </p>
        </div>

        <div className="mt-14 relative">
          <div className="absolute left-0 right-0 top-8 h-px bg-gradient-to-r from-transparent via-[#E0A72C]/50 to-transparent hidden lg:block" aria-hidden />
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((s, i) => (
              <div key={i} className="relative bg-[#FAF7F2] rounded-2xl p-6 border border-slate-100 hover:border-[#E0A72C]/70 hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 rounded-full bg-white border-2 border-[#E0A72C] text-[#B8892A] font-extrabold flex items-center justify-center text-lg shadow">
                  {s.n}
                </div>
                <h3 className="mt-5 font-bold text-[#0B1E44] text-lg">{s.t}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 text-center">
          <a href="#kontakt" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-md text-[15px]">Jetzt unverbindlich anfragen</a>
        </div>
      </div>
    </section>
  );
}

export function Areas() {
  return (
    <section id="einsatzgebiet" className="py-20 md:py-28 bg-[#0B1E44] text-white relative overflow-hidden">
      <div className="absolute inset-0 dotted-bg opacity-20" aria-hidden />
      <div className="absolute -top-24 right-0 w-[500px] h-[500px] rounded-full bg-[#DC2626]/15 blur-3xl" aria-hidden />
      <div className="absolute -bottom-24 left-0 w-[500px] h-[500px] rounded-full bg-[#E0A72C]/10 blur-3xl" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#E0A72C]">Einsatzgebiet</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
            Sanierung & Objektpflege in <span className="gold-text">Norddeutschland & Bayern</span>.
          </h2>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            Wir sind vor Ort in Norddeutschland und Bayern – Anfragen aus weiteren Regionen bearbeiten wir nach Absprache.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          {areas.map((a) => (
            <div key={a} className="inline-flex items-center gap-2 bg-white/5 border border-white/15 hover:border-[#E0A72C]/60 hover:bg-white/10 rounded-full pl-3 pr-4 py-2 text-sm text-white/90 transition-colors">
              <MapPin className="w-4 h-4 text-[#E0A72C]" /> {a}
            </div>
          ))}
          <div className="inline-flex items-center gap-2 border border-dashed border-white/25 rounded-full pl-3 pr-4 py-2 text-sm text-white/70">
            + weitere Regionen n. Absprache
          </div>
        </div>

        <p className="mt-8 text-white/60 text-sm max-w-2xl">
          Auch wenn Ihr Ort nicht aufgeführt ist, fragen Sie gerne unverbindlich an – je nach Objektgröße und Entfernung sind weitere Regionen möglich.
        </p>
      </div>
    </section>
  );
}
